import { useTranslation } from "react-i18next";
import { trips as baseTrips, species as baseSpecies, testimonials as baseTest, faqs as baseFaqs } from "../data/mock";
import en from "./data/en.json";
import es from "./data/es.json";
import de from "./data/de.json";
import fr from "./data/fr.json";
import it from "./data/it.json";
import pt from "./data/pt.json";
import ru from "./data/ru.json";
import zh from "./data/zh.json";

const DATA = { en, es, de, fr, it, pt, ru, zh };

function useData() {
  const { i18n } = useTranslation();
  return DATA[i18n.resolvedLanguage] || DATA.en;
}

export function useTrips() {
  const d = useData();
  return baseTrips.map((t) => ({ ...t, ...((d.trips && d.trips[t.slug]) || {}) }));
}
export function useTrip(slug) {
  return useTrips().find((t) => t.slug === slug);
}
export function useSpeciesList() {
  const d = useData();
  return baseSpecies.map((s) => ({ ...s, ...((d.species && d.species[s.slug]) || {}) }));
}
export function useSpecies(slug) {
  return useSpeciesList().find((s) => s.slug === slug);
}
export function useTestimonials() {
  const d = useData();
  return baseTest.map((r, i) => ({ ...r, ...((d.testimonials && d.testimonials[i]) || {}) }));
}
export function useFaqs() {
  const d = useData();
  return baseFaqs.map((f, i) => ({ ...f, ...((d.faqs && d.faqs[i]) || {}) }));
}
